import { IEmployeeLevel, IExperienceLevel } from 'src/graphql/auto-generated/graphql';

export * from 'src/routes/routeUrl';
export * from './validationMessage';

export const ExperienceLevelOption = [
  { label: 'Beginner', value: IExperienceLevel.BEGINNER },
  { label: 'Mid-Level', value: IExperienceLevel.MID_LEVEL },
  { label: 'Senior', value: IExperienceLevel.SENIOR },
  { label: 'Expert', value: IExperienceLevel.EXPERT },
];
export const regionListOption = [
  { label: 'Nepal', value: 'Nepal' },
  { label: 'LATAM', value: 'LATAM' },
  { label: 'N. America', value: 'N. America' },
  { label: 'South Asia', value: 'South Asia' },
];

export const ExperienceLevelOffboardAndReplace = [
  { label: 'Junior', value: IEmployeeLevel.JUNIOR_LEVEL },
  { label: 'Mid Level', value: IEmployeeLevel.MID_LEVEL },
  { label: 'Senior', value: IEmployeeLevel.SENIOR_LEVEL },
];

export const color = ['#6d49b1', '#6EC57B', '#FFC617', '#5B90EB', '#5B90EB'];
export const pyramidBarGraphColor = ['#5B90EB', '#FFC617', '#6EC57B', '#6d49b1'];

export const doughnutGraphColor = [
  '#6d49b1',
  '#6EC57B',
  '#FFC617',
  '#5B90EB',
  '#FD71AF',
  '#F48268',
  '#8984F0',
  '#ea5545',
  '#ede15b',
  '#7c1158',
  '#4421af',
];

export const skillColor = ['orange', 'blue', 'green', 'yellow'];

export const getShortName = (value: string | undefined | null) => {
  return value?.split(/\s/).reduce((res, word) => (res += word.slice(0, 1)), '');
};
export const progressBarColor = ['blue', 'yellow', 'red', 'green', 'purple', 'orange'];

export const personaColor = ['blue', 'orange', 'red', 'purple', 'yellow', 'magenta', 'green'];
